export const ROLE_SCOPE = {
  DEFAULT: "default",
  COMPANY: "company",
  HOTEL: "hotel",
};

export const FEATURES = {
  DASHBOARD: "dashboard",
  RESERVATIONS: "reservations",
  DRAFT: "draft",
  CHECK_IN: "check_in",
  CHECK_OUT: "check_out",
  GUEST_MANAGEMENT: "guest_management",
  ROOM_MANAGEMENT: "room_management",
  ADDONS: "addons",
  NIGHT_AUDIT: "night_audit_process",

  HOUSEKEEPING_TASKS: "housekeeping_tasks",

  BILLING: "billing",
  CHARGE_POSTING: "charge_posting",
  PAYMENTS: "payments",

  ADMIN_DASHBOARD: "admin_dashboard",
  OCCUPANCY_REPORT: "occupancy_report",
  REVENUE_REPORT: "revenue_report",

  HOTEL_SETTINGS: "hotel_settings",
  USER_MANAGEMENT: "user_management",
  ROLE_MANAGEMENT: "role_management",
  AUDIT_MANAGEMENT: "audit_management",
  STAFF_MANAGEMENT: "staff_management",
  RATE_PLAN: "rate_plan",

  INVENTORY_ITEMS: "inventory_items",

  LAUNDRY_MASTER: "laundry_master",
  LAUNDRY_CONFIG: "laundry_config",
  LAUNDRY_REQUESTS: "laundry_requests",
  LAUNDRY_OPERATIONS: "laundry_operations",
  LAUNDRY_NON_REVENUE: "laundry_non_revenue",
  LAUNDRY_VENDOR: "laundry_vendor",
  LAUNDRY_BILLING: "laundry_billing",
  LAUNDRY_COMPLAINTS: "laundry_complaints",
  LAUNDRY_REPORTS: "laundry_reports",

  NIGHT_AUDIT_REPORT: "night_audit_report",
  NIGHT_AUDIT_OPERATIONAL_REPORT: "night_audit_operational_report",
  HOUSEKEEPING_REPORT: "housekeeping_report",
  PAID_OUT: "paid_out",
  GUEST_DISBURSEMENT: "guest_disbursement",
  SALES_REPORT: "sales_report",
  GST_REPORT: "gst_report",
  FOREIGNER_REPORT: "foreigner_report",
  CANCELLATION_REPORT: "cancellation_report",
  GUEST_REPORT: "guest_report",
  COLLECTION_REPORT: "collection_report",
  REFUNDS: "refunds",
  NOTIFICATION_SETTINGS: "notification_settings",
  BOOKING_ENGINE_CONFIG: "booking_engine_config",
  CUSTOMER_SUPPORT: "customer_support",
  COUPONS: "coupons",
  GUEST_OFFERS: "guest_offers",
  CHANNEL_MANAGEMENT: "channel_management",
  TUTORIAL: "tutorial",
  TUTORIAL_MANAGEMENT: "tutorial_management",
  APPROVAL_WORKFLOW: "approval_workflow",
  AUTHORIZATION_PROCESSING: "authorization_processing",

  // --- CRM ---
  CRM_GUEST_DIRECTORY: "crm_guest_directory",
  CRM_GUEST_PROFILE: "crm_guest_profile",
  CRM_GUEST_PII: "crm_guest_pii",
  CRM_GUEST_FINANCIAL: "crm_guest_financial",
  CRM_GUEST_PREFERENCES: "crm_guest_preferences",
  CRM_SPECIAL_CATEGORY: "crm_special_category",
  CRM_GUEST_COMMUNICATION: "crm_guest_communication",
  CRM_GUEST_DOCUMENTS: "crm_guest_documents",
  CRM_GUEST_MERGE: "crm_guest_merge",
  CRM_OTA_CONVERSION: "crm_ota_conversion",
};

export const ACTIONS = {
  VIEW: "view",
  CREATE: "create",
  UPDATE: "update",
  DELETE: "delete",
  EXPORT: "export",

  CANCEL_RESERVATION: "cancel_reservation",
  ROOM_SHIFT: "room_shift",
  EXTEND_STAY: "extend_stay",

  UNDO_DEPARTURE: "undo_departure",

  BLOCK_GUEST: "block_guest",
  UNBLOCK_GUEST: "unblock_guest",
  PRINT_GRC: "print_grc",

  BLOCK_ROOM: "block_room",
  UNBLOCK_ROOM: "unblock_room",

  CANCEL_INVOICE: "cancel_invoice",
  PROVISIONAL_BILL: "provisional_bill",
  RECORD_PAYMENT: "record_payment",
  PAYMENT_HISTORY: "payment_history",

  RESET_PASSWORD: "reset_password",
  DEACTIVATE: "deactivate",
  ACTIVATE: "activate",

  APPROVE: "approve",
  REJECT: "reject",

  CANCEL_LAUNDRY_REQUEST: "cancel_laundry_request",
  MERGE: "merge",
};

export const USER_STATUS = {
  PENDING_ACTIVATION: "pending_activation",
  ACTIVE: "active",
  INACTIVE: "inactive",
  LOCKED: "locked",
};

export const USER_STATUS_LABELS = {
  [USER_STATUS.PENDING_ACTIVATION]: "Pending Activation",
  [USER_STATUS.ACTIVE]: "Active",
  [USER_STATUS.INACTIVE]: "Inactive",
  [USER_STATUS.LOCKED]: "Locked",
};
